/**
 * The various major z-index layers, adjust with caution and leave space between to add to later.
 */
export const Layers = {
    Modal: 1000,
};
